/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsDeleteAccount204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsDeleteAccount505Schema = z.any();

export const optionsDeleteAccountMutationResponseSchema = z.lazy(() => optionsDeleteAccount204Schema);
